import { Stack } from '@eneco/sparky';
import { StackProps } from '@eneco/sparky/types';

import { alignYBaselineClass } from '../styles/components.css';

const AlignYBaseline = (props: StackProps) => {
  return <Stack className={alignYBaselineClass} direction="row" gap="1" {...props} />;
};

export default AlignYBaseline;
